import { resolveInstancePath } from './SubResourceResolver.js';
/** The host child `node` stands for: itself, or the child it is the re-anchored copy of. */
export function hostChildOf(node) {
    return node.reanchoredFrom ?? node;
}
/**
 * The scope a node's refs and its children's resolve against: its own, else its group's.
 * A group does not stamp its children with it: solve-tree maps key on the raw node, and a copy breaks them.
 */
export function scopeOf(node, groupScope) {
    return node.scope ?? groupScope;
}
/**
 * `node` stamped with `scope` where it carries none: a node moved into another scene's tree keeps
 * the pools of the file that authored it.
 */
export function withFallbackScope(node, scope) {
    return node.scope ? node : { ...node, scope };
}
/**
 * The `res://` path of the scene `node` instances, its ref resolved in the scope of the file that
 * authored it ({@link scopeOf}). Null for a node with no instance ref, or a ref that scope does not
 * declare.
 */
export function liveInstancePath(node, groupScope) {
    if (!node.instance)
        return null;
    return resolveInstancePath(node.instance, scopeOf(node, groupScope).externalResources);
}
//# sourceMappingURL=liveNode.js.map